<template>
  <f-group :label="label" :hint="hint">
    <div class="custom-file">
      <input
        ref="input"
        type="file"
        :class="['custom-file-input font-weight-normal', { 'is-invalid': isInvalid || !!validationError }]"
        :id="id"
        :accept="accept"
        :required="required"
        @change="onChange"
      >
      <label class="custom-file-label font-weight-normal" :for="id">
        {{ fileName || 'Select File' }}
      </label>
      <div class="invalid-tooltip" v-if="validationError">{{ validationError }}</div>
      <div class="invalid-tooltip" v-else-if="tooltip">{{ tooltip }}</div>
    </div>
  </f-group>
</template>

<script>
import FGroup from './Base/FGroup'


function formatSize(bytes) {
  if (bytes >= 1048576) return `${(bytes / 1048576).toFixed(0)} MB`
  return `${(bytes / 1024).toFixed(0)} KB`
}

export default {
  name: 'FFile',
  components: { FGroup },
  props: {
    label: String,
    id: { type: String, required: true },
    accept: String,
    required: Boolean,
    displayName: String,
    isInvalid: Boolean,
    tooltip: String,
    hint: String,
    maxSize: { type: Number, default: 1048576 }
  },
  data() {
    return {
      fileName: this.displayName || '',
      validationError: null
    }
  },
  watch: {
    displayName(val) {
      this.fileName = val || ''
    }
  },
  methods: {
    onChange(event) {
      const file = event.target.files[0]
      if (!file) {
        this.validationError = null
        this.fileName = ''
        return
      }

      const sizeError = this.validateSize(file)
      if (sizeError) {
        this.validationError = sizeError
        this.fileName = ''
        this.$refs.input.value = ''
        return
      }

      const typeError = this.validateType(file)
      if (typeError) {
        this.validationError = typeError
        this.fileName = ''
        this.$refs.input.value = ''
        return
      }

      this.validationError = null
      this.fileName = file.name
      this.$emit('change', event)
    },

    validateSize(file) {
      if (file.size > this.maxSize) {
        return `File is too large. Maximum size is ${formatSize(this.maxSize)}.`
      }
      return null
    },

    validateType(file) {
      if (!this.accept) return null

      const tokens = this.accept.split(',').map(t => t.trim().toLowerCase())
      const fileExt = file.name.split('.').pop().toLowerCase()

      const allowed = tokens.some((token) => {
        const normalized = token.startsWith('.') ? token : `.${token}`
        if (normalized.includes('/')) {
          return token.endsWith('/*')
            ? file.type.startsWith(token.slice(0, -1))
            : file.type === token
        }
        return file.name.toLowerCase().endsWith(normalized) || fileExt === token.replace(/^\./, '')
      })

      if (!allowed) {
        const exts = tokens.map(t => (t.startsWith('.') ? t.slice(1) : t)).join(', ')
        return `Invalid file type. Allowed: ${exts}.`
      }
      return null
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/FormFields/FFile.vue